<template>
  <Header :title="$t('userManagement.title')" />

  <div class="userManagementContainer">
    <div class="pageContainerJob" style="height: 100% !important">
      <!-- Back Header -->
      <div class="createUserHeader">
        <svg @click="handleBackToUsers" style="cursor: pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
          <path d="M5.25 11.25H20.25C20.45 11.25 20.64 11.33 20.78 11.47C20.92 11.61 21 11.8 21 12C21 12.2 20.92 12.39 20.78 12.53C20.64 12.67 20.45 12.75 20.25 12.75H5.25C5.05 12.75 4.86 12.67 4.72 12.53C4.58 12.39 4.5 12.2 4.5 12C4.5 11.8 4.58 11.61 4.72 11.47C4.86 11.33 5.05 11.25 5.25 11.25Z" fill="black" />
          <path d="M5.56 12L11.78 18.22C11.92 18.36 12 18.55 12 18.75C12 18.95 11.92 19.14 11.78 19.28C11.64 19.42 11.45 19.5 11.25 19.5C11.05 19.5 10.86 19.42 10.72 19.28L3.97 12.53C3.9 12.46 3.84 12.38 3.81 12.29C3.77 12.2 3.75 12.1 3.75 12C3.75 11.9 3.77 11.8 3.81 11.71C3.84 11.62 3.9 11.54 3.97 11.47L10.72 4.72C10.86 4.58 11.05 4.5 11.25 4.5C11.45 4.5 11.64 4.58 11.78 4.72C11.92 4.86 12 5.05 12 5.25C12 5.45 11.92 5.64 11.78 5.78L5.56 12Z" fill="black" />
        </svg>
        <span class="newPageTitle">{{ $t('userManagement.pages.edit.title') }}</span>
      </div>

      <div v-if="loading" class="loading-spinner">Loading...</div>

      <div v-else class="createUserBody">
        <div class="form-field">
          <label>{{ $t('userManagement.forms.labels.first_name') }}</label>
          <input type="text" v-model="userData.first_name" :placeholder="$t('userManagement.forms.placeholders.first_name')" maxlength="100" @input="validateFirstName" />
          <div v-if="fieldErrors.first_name" class="field-error">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99992 14.6666C4.31792 14.6666 1.33325 11.6819 1.33325 7.99992C1.33325 4.31792 4.31792 1.33325 7.99992 1.33325C11.6819 1.33325 14.6666 4.31792 14.6666 7.99992C14.6666 11.6819 11.6819 14.6666 7.99992 14.6666ZM7.99992 13.8666C9.55585 13.8666 11.0481 13.2485 12.1483 12.1483C13.2485 11.0481 13.8666 9.55585 13.8666 7.99992C13.8666 6.44398 13.2485 4.95177 12.1483 3.85156C11.0481 2.75135 9.55585 2.13325 7.99992 2.13325C6.44398 2.13325 4.95177 2.75135 3.85156 3.85156C2.75135 4.95177 2.13325 6.44398 2.13325 7.99992C2.13325 9.55585 2.75135 11.0481 3.85156 12.1483C4.95177 13.2485 6.44398 13.8666 7.99992 13.8666ZM7.55992 4.28725H8.43992L8.38058 8.99392H7.61992L7.56125 4.28725H7.55992ZM7.99992 11.3819C7.92657 11.3828 7.85378 11.369 7.78584 11.3414C7.7179 11.3137 7.65617 11.2727 7.6043 11.2209C7.55243 11.169 7.51146 11.1073 7.4838 11.0393C7.45614 10.9714 7.44236 10.8986 7.44325 10.8253C7.44189 10.7518 7.45537 10.6788 7.48286 10.6106C7.51036 10.5425 7.55131 10.4806 7.60327 10.4286C7.65524 10.3766 7.71715 10.3357 7.7853 10.3082C7.85345 10.2807 7.92644 10.2672 7.99992 10.2686C8.31725 10.2686 8.55658 10.5086 8.55658 10.8253C8.55794 10.8987 8.54447 10.9717 8.51698 11.0399C8.48948 11.108 8.44853 11.1699 8.39656 11.2219C8.3446 11.2739 8.28269 11.3148 8.21454 11.3423C8.14639 11.3698 8.07339 11.3833 7.99992 11.3819Z" fill="#E50006" stroke="#E50006" stroke-width="0.2" />
            </svg>
            {{ fieldErrors.first_name }}
          </div>
        </div>

        <div class="form-field">
          <label>{{ $t('userManagement.forms.labels.last_name') }}</label>
          <input type="text" v-model="userData.last_name" :placeholder="$t('userManagement.forms.placeholders.last_name')" maxlength="100" @input="validateLastName" />
          <div v-if="fieldErrors.last_name" class="field-error">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99992 14.6666C4.31792 14.6666 1.33325 11.6819 1.33325 7.99992C1.33325 4.31792 4.31792 1.33325 7.99992 1.33325C11.6819 1.33325 14.6666 4.31792 14.6666 7.99992C14.6666 11.6819 11.6819 14.6666 7.99992 14.6666ZM7.99992 13.8666C9.55585 13.8666 11.0481 13.2485 12.1483 12.1483C13.2485 11.0481 13.8666 9.55585 13.8666 7.99992C13.8666 6.44398 13.2485 4.95177 12.1483 3.85156C11.0481 2.75135 9.55585 2.13325 7.99992 2.13325C6.44398 2.13325 4.95177 2.75135 3.85156 3.85156C2.75135 4.95177 2.13325 6.44398 2.13325 7.99992C2.13325 9.55585 2.75135 11.0481 3.85156 12.1483C4.95177 13.2485 6.44398 13.8666 7.99992 13.8666ZM7.55992 4.28725H8.43992L8.38058 8.99392H7.61992L7.56125 4.28725H7.55992ZM7.99992 11.3819C7.92657 11.3828 7.85378 11.369 7.78584 11.3414C7.7179 11.3137 7.65617 11.2727 7.6043 11.2209C7.55243 11.169 7.51146 11.1073 7.4838 11.0393C7.45614 10.9714 7.44236 10.8986 7.44325 10.8253C7.44189 10.7518 7.45537 10.6788 7.48286 10.6106C7.51036 10.5425 7.55131 10.4806 7.60327 10.4286C7.65524 10.3766 7.71715 10.3357 7.7853 10.3082C7.85345 10.2807 7.92644 10.2672 7.99992 10.2686C8.31725 10.2686 8.55658 10.5086 8.55658 10.8253C8.55794 10.8987 8.54447 10.9717 8.51698 11.0399C8.48948 11.108 8.44853 11.1699 8.39656 11.2219C8.3446 11.2739 8.28269 11.3148 8.21454 11.3423C8.14639 11.3698 8.07339 11.3833 7.99992 11.3819Z" fill="#E50006" stroke="#E50006" stroke-width="0.2" />
            </svg>
            {{ fieldErrors.last_name }}
          </div>
        </div>

        <div class="form-field">
          <label>{{ $t('userManagement.forms.labels.email') }}</label>
          <input type="email_id" v-model="userData.email_id" :placeholder="$t('userManagement.forms.placeholders.email')" disabled />
        </div>

        <div class="form-field">
          <label>{{ $t('userManagement.forms.labels.phone') }}</label>
          <input type="number" v-model="userData.phone_number" :placeholder="$t('userManagement.forms.placeholders.phone')" @input="validatePhoneNumber" />
          <div v-if="fieldErrors.phone_number" class="field-error">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99992 14.6666C4.31792 14.6666 1.33325 11.6819 1.33325 7.99992C1.33325 4.31792 4.31792 1.33325 7.99992 1.33325C11.6819 1.33325 14.6666 4.31792 14.6666 7.99992C14.6666 11.6819 11.6819 14.6666 7.99992 14.6666ZM7.99992 13.8666C9.55585 13.8666 11.0481 13.2485 12.1483 12.1483C13.2485 11.0481 13.8666 9.55585 13.8666 7.99992C13.8666 6.44398 13.2485 4.95177 12.1483 3.85156C11.0481 2.75135 9.55585 2.13325 7.99992 2.13325C6.44398 2.13325 4.95177 2.75135 3.85156 3.85156C2.75135 4.95177 2.13325 6.44398 2.13325 7.99992C2.13325 9.55585 2.75135 11.0481 3.85156 12.1483C4.95177 13.2485 6.44398 13.8666 7.99992 13.8666ZM7.55992 4.28725H8.43992L8.38058 8.99392H7.61992L7.56125 4.28725H7.55992ZM7.99992 11.3819C7.92657 11.3828 7.85378 11.369 7.78584 11.3414C7.7179 11.3137 7.65617 11.2727 7.6043 11.2209C7.55243 11.169 7.51146 11.1073 7.4838 11.0393C7.45614 10.9714 7.44236 10.8986 7.44325 10.8253C7.44189 10.7518 7.45537 10.6788 7.48286 10.6106C7.51036 10.5425 7.55131 10.4806 7.60327 10.4286C7.65524 10.3766 7.71715 10.3357 7.7853 10.3082C7.85345 10.2807 7.92644 10.2672 7.99992 10.2686C8.31725 10.2686 8.55658 10.5086 8.55658 10.8253C8.55794 10.8987 8.54447 10.9717 8.51698 11.0399C8.48948 11.108 8.44853 11.1699 8.39656 11.2219C8.3446 11.2739 8.28269 11.3148 8.21454 11.3423C8.14639 11.3698 8.07339 11.3833 7.99992 11.3819Z" fill="#E50006" stroke="#E50006" stroke-width="0.2" />
            </svg>
            {{ fieldErrors.phone_number }}
          </div>
        </div>

        <div v-if="userData.status !== 'Invited'" class="form-field">
          <label>{{ $t('userManagement.forms.labels.status') }}</label>
          <select v-model="userData.status">
            <option value="Active">{{ $t('userManagement.status.active') }}</option>
            <option value="Inactive">{{ $t('userManagement.status.inactive') }}</option>
          </select>
        </div>

        <!-- <div class="form-field">
          <label>{{ $t('filters.roles_label') }}</label>
          <select v-model="userData.roleId">
            <option disabled value="">Please select a Role</option>
            <option v-for="role in roles" :key="role.id" :value="role.id">
              {{ role.roleName }}
            </option>
          </select>
        </div> -->

        <div class="form-field" v-if="userData.roleId && userData.roleId !== 2">
          <label>{{ $t('userManagement.forms.labels.tenant') }}</label>
          <select v-model="userData.tenant_id">
            <option disabled value="">{{ $t('userManagement.forms.placeholders.select_tenant') }}</option>
            <option v-for="tenant in tenants" :key="tenant.id" :value="tenant.id">
              {{ tenant.tenant_name }}
            </option>
          </select>
        </div>

        <div class="button-group">
          <button class="cancel-btn" @click="cancel">{{ $t('userManagement.buttons.cancel') }}</button>
          <button class="invite-btn" @click="updateUser">{{ $t('userManagement.pages.edit.update_button') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import { get, put } from '@/utils/api'
import eventBus from '@/utils/eventBus'
import { showToast } from '@/utils/toast.js'

export default {
  components: {
    Header,
  },
  data() {
    return {
      loading: false,
      tenants: [],
      roles: [],
      userData: {
        first_name: '',
        last_name: '',
        email_id: '',
        phone_number: '',
        roleId: '',
        tenant_id: '',
        status: 'Active',
        is_active: true,
      },
      fieldErrors: {
        first_name: '',
        last_name: '',
        phone_number: '',
        email_id: '',
        roleId: '',
      },
    }
  },

  async mounted() {
    document.title = 'Edit User'
    await this.fetchUserDetails()
    await Promise.all([this.fetchTenants(), this.fetchRoles()])
  },

  methods: {
    // ======================
    // API CALLS
    // ======================
    async fetchUserDetails() {
      this.loading = true
      try {
        const userId = this.$route.params.id
        const response = await get(`/v1/users/${userId}`)

        if (response?.data?.code === 200) {
          this.userData = response.data.data
        }
      } catch (error) {
        eventBus.emit('show-toast', {
          title: this.$t('userManagement.messages.error_title'),
          message: this.$t('userManagement.messages.error.fetch_failed'),
          type: 'error',
        })
      } finally {
        this.loading = false
      }
    },

    async fetchTenants() {
      try {
        const res = await get('/v1/tenants?page=1&pageSize=100000')
        if (res?.data?.code === 200) {
          this.tenants = res.data.data.tenants || []
        }
      } catch (err) {}
    },

    async fetchRoles() {
      try {
        const res = await get('/v1/roles')
        if (res?.data?.code === 200) {
          this.roles = res.data.data.roles?.filter((role) => role.roleName !== 'SYSTEM ROLE') || []
        }
      } catch (err) {}
    },

    async updateUser() {
      this.validateFirstName()
      this.validateLastName()
      this.validatePhoneNumber()

      if (this.fieldErrors.first_name || this.fieldErrors.last_name || this.fieldErrors.phone_number) {
        return
      }

      this.loading = true
      try {
        const userId = this.$route.params.id
        const response = await put(`/v1/users/${userId}`, this.userData)

        if (response?.data?.code === 200) {
          showToast({
            title: this.$t('userManagement.messages.success_title'),
            message: this.$t('userManagement.messages.success.user_updated'),
            type: 'success',
          })
        } else {
          showToast({
            title: this.$t('userManagement.messages.error_title'),
            message: this.$t('userManagement.messages.error.unexpected_response'),
            type: 'error',
          })
        }
      } catch (error) {
        showToast({
          title: this.$t('userManagement.messages.error_title'),
          message: this.$t('userManagement.messages.error.update_failed'),
          type: 'error',
        })
      } finally {
        this.loading = false
      }
    },

    validateFirstName() {
      const name = this.userData.first_name
      this.fieldErrors.first_name = name.length > 100 ? this.$t('userManagement.forms.validation.first_name_max') : ''
      if (name.length > 100) {
        this.userData.first_name = name.slice(0, 100)
      }
    },

    validateLastName() {
      const name = this.userData.last_name
      this.fieldErrors.last_name = name.length > 100 ? this.$t('userManagement.forms.validation.last_name_max') : ''
      if (name.length > 100) {
        this.userData.last_name = name.slice(0, 100)
      }
    },

    validatePhoneNumber() {
      let phone = this.userData.phone_number?.toString() || ''
      if (phone.length > 10) {
        this.fieldErrors.phone_number = this.$t('userManagement.forms.validation.phone_max')
        phone = phone.slice(0, 10)
      } else {
        this.fieldErrors.phone_number = ''
      }
      this.userData.phone_number = phone
    },

    cancel() {
      this.$router.go(-1)
    },

    handleBackToUsers() {
      const tenantName = localStorage.getItem('url_name')
      this.$router.push(`/${tenantName}/users-management`)
    },
  },
}
</script>

<style scoped>
/* Reuse the same styles from CreateUser.vue */
.createUserHeader {
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 9px;
}

.newPageTitle {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 28px;
  font-weight: 500;
  line-height: 150%;
}

.createUserBody {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.form-field label {
  color: #8b8888;
  font-family: Archivo;
  font-size: 18px;
  font-weight: 400;
  display: block;
  margin-bottom: 6px;
}

.form-field input,
.form-field select {
  width: 579px;
  height: 47px;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #dbdbdb;
  font-family: Archivo;
  font-size: 16px;
  color: #32393e;
}

.button-group {
  margin-top: 20px;
  display: flex;
  gap: 20px;
}

.cancel-btn {
  padding: 10px 32px;
  background: transparent;
  border: 1px solid var(--primary-color);
  color: var(--primary-color);
  font-family: Archivo;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
}

.invite-btn {
  padding: 10px 32px;
  background: var(--primary-color);
  color: white;
  font-family: Archivo;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

.form-field input[disabled] {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.error-message {
  color: #e50006;
  font-family: Archivo;
  font-size: 12px;
  margin-top: 4px;
}

/* Remove arrows from number input */
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>
